import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pay-utility-bills-form',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './pay-utility-bills-form.html',
  styleUrl: './pay-utility-bills-form.scss',
})
export class PayUtilityBillsForm {
  @Input() category: any = { name: 'Electricity' };
  @Output() close = new EventEmitter<void>();

  currentStep: 'recent' | 'add-new' | 'details' | 'success' = 'recent';

  recentPayments = [
    {
      id: 1,
      billerName: 'Tata Power',
      consumerId: '****2345',
      lastBill: '1,850',
      icon: 'assets/icons/img-bank.svg'
    }
  ];

  newBiller = {
    name: 'Tata Power',
    consumerNumber: '567891234',
    stateCity: 'HDFC0001234'
  };

  billDetails = {
    biller: 'Tata Power',
    period: 'March 2026',
    dueDate: '25 March',
    amount: '1,850'
  };

  selectedCard = {
    name: 'Credit Card 1',
    lastFour: '1234'
  };

  paymentCards = [
    { name: 'Credit Card 1', lastFour: '1234', icon: 'assets/icons/card.svg' },
    { name: 'Debit Card 1', lastFour: '5678', icon: 'assets/icons/card.svg' },
    { name: 'HDFC Savings', lastFour: '9012', icon: 'assets/icons/img-bank.svg' },
    { name: 'ICICI Account', lastFour: '3456', icon: 'assets/icons/img-bank.svg' }
  ];

  showCardDropdown = false;

  toggleCardDropdown() {
    this.showCardDropdown = !this.showCardDropdown;
  }

  selectCard(card: any) {
    this.selectedCard = card;
    this.showCardDropdown = false;
  }

  nextStep() {
    if (this.currentStep === 'recent') this.currentStep = 'details';
    else if (this.currentStep === 'add-new') this.currentStep = 'details';
    else if (this.currentStep === 'details') this.currentStep = 'success';
  }

  goBack() {
    if (this.currentStep === 'recent') this.close.emit();
    else if (this.currentStep === 'add-new') this.currentStep = 'recent';
    else if (this.currentStep === 'details') this.currentStep = 'recent';
  }

  setStep(step: any) {
    this.currentStep = step;
  }
}
